var _rect, _g, _rect2, _rect3, _rect4, _rect5, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 300,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 180 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 230,
    height: 145,
    rx: 14,
    fill: "#1f5675"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 85,
    width: 230,
    height: 145,
    rx: 14,
    fill: "#347BA2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 112,
    width: 230,
    height: 28,
    fill: "#1f3f52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 160,
    width: 36,
    height: 26,
    rx: 4,
    fill: "#f2c94c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 200,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#ffffff",
    opacity: 0.85
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 200,
    r: 16,
    fill: "#ffffff",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 200,
    r: 16,
    fill: "#ffffff",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayNow);
export default __webpack_public_path__ + "static/media/pay-now.ca7eeb81de2cb92469636e5fffbd6ad3.svg";
export { ForwardRef as ReactComponent };